export const CHECK_CUSTOMER_REQUEST = 'CHECK_CUSTOMER_REQUEST'
export const SUBSCRIPTIONS_REQUEST = 'SUBSCRIPTIONS_REQUEST'
export const CONFIG_REQUEST = 'CONFIG_REQUEST'
export const CHECK_CHANGE = 'CHECK_CHANGE'
export const CHECK_SELECT_ALL = 'CHECK_SELECT_ALL'
export const SAVE_REQUEST = 'SAVE_REQUEST'
export const CLOSE_POPUP = 'CLOSE_POPUP'
export const DISABLED_BTN = 'DISABLED_BTN'
export const ERROR_POPUP = 'ERROR_POPUP'
export const MOBILE_MENU = 'MOBILE_MENU'
export const CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID'
export const HOVER_ALL = 'HOVER_ALL'
export const MOBILE_MENU_OPEN_ITEM = 'MOBILE_MENU_OPEN_ITEM'
export const MOBILE_GUIDES = 'MOBILE_GUIDES'

